require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-oberpullendorf-neckenmarkt.json") })
        }
      }, "path---betreuungseinrichtungen-oberpullendorf-neckenmarkt");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-oberpullendorf-neckenmarkt!./.cache/json/betreuungseinrichtungen-oberpullendorf-neckenmarkt.json
// module id = 984
// module chunks = 231608221292675